<template>
	<v-card flat outlined>
		<v-container fluid class="pb-0">
			<v-row>
				<v-col cols="12" lg="12" class="pb-0 pt-0">
					<v-card flat class="pb-0 pt-0">
						<v-card-text class="pb-0">
							<v-row>
								<v-col class="pb-0 pt-0">
									<v-card-title class="justify-center align-center pa-2 pb-0 pt-0">{{
										$t('titles.statsCosts')
									}}</v-card-title>
								</v-col>
							</v-row>
							<v-row>
								<v-col class="pt-0">
									<TheTable
										:additional-filters="statsCostsTable.additionalFilters"
										:default-sort="statsCostsTable.defaultSort"
										:excel="true"
										:fields="statsCostsTable.headers"
										:header-selection-key="'stats-costs-headers'"
										:height="statsCostsTable.height"
										:total-records="statsCostsTable.total"
										:filter-save-key="'stats-costs-filters'"
										@excel="excelExport"
										@headers="selectHeaders"
										@reload="reloadData"
									>
										<tr
											v-for="(item, key) in statsCostsTable.items"
											:key="key"
											:class="{ 'cursor-pointer': true }"
										>
											<td v-if="statsCostsTable.selectedHeaders.includes('type')">
												{{ item.type ? 'Predavanje' : 'Ostalo' }}
											</td>
											<td v-if="statsCostsTable.selectedHeaders.includes('teacher')">
												{{ item.teacher }}
											</td>
											<td v-if="statsCostsTable.selectedHeaders.includes('code')">
												{{
													item.code +
													' - ' +
													item.start_date.split('-').reverse().join('.') +
													'.'
												}}
											</td>
											<td v-if="statsCostsTable.selectedHeaders.includes('office')">
												{{ item.office }}
											</td>
											<td v-if="statsCostsTable.selectedHeaders.includes('date')">
												{{ item.date.split('-').reverse().join('.') + '.' }}
											</td>
											<td
												style="text-align: right"
												v-if="statsCostsTable.selectedHeaders.includes('unit_price')"
											>
												{{
													Number(item.unit_price) % 1 !== 0
														? item.unit_price.charAt(item.unit_price.length - 2) !== '0' &&
														  item.unit_price.endsWith('0')
															? Number(item.unit_price).toLocaleString('hr') + '0'
															: Number(item.unit_price).toLocaleString('hr')
														: Number(item.unit_price).toLocaleString('hr') + ',00'
												}}
											</td>
											<td
												style="text-align: right"
												v-if="statsCostsTable.selectedHeaders.includes('quantity')"
											>
												{{
													Number(item.quantity) % 1 !== 0
														? item.quantity.charAt(item.quantity.length - 2) !== '0' &&
														  item.quantity.endsWith('0')
															? Number(item.quantity).toLocaleString('hr') + '0'
															: Number(item.quantity).toLocaleString('hr')
														: Number(item.quantity).toLocaleString('hr') + ',00'
												}}
											</td>
											<td
												style="text-align: right"
												v-if="statsCostsTable.selectedHeaders.includes('total')"
											>
												{{
													Number(item.total) % 1 !== 0
														? item.total.charAt(item.total.length - 2) !== '0' &&
														  item.total.endsWith('0')
															? Number(item.total).toLocaleString('hr') + '0'
															: Number(item.total).toLocaleString('hr')
														: Number(item.total).toLocaleString('hr') + ',00'
												}}
											</td>
										</tr>
										<!-- <tr>
											<td></td>
											<td></td>
											<td style="text-align: right">
												{{
													incomeSum != null
														? Number.isInteger(incomeSum)
															? incomeSum.toLocaleString('hr') + ',00'
															: /^\d+\.\d{1}$/.test(incomeSum.toString())
															? incomeSum.toLocaleString('hr') + '0'
															: incomeSum.toLocaleString('hr')
														: ''
												}}
											</td>
											<td style="text-align: right">
												{{
													discountSum != null
														? Number.isInteger(discountSum)
															? discountSum.toLocaleString('hr') + ',00'
															: /^\d+\.\d{1}$/.test(discountSum.toString())
															? discountSum.toLocaleString('hr') + '0'
															: discountSum.toLocaleString('hr')
														: ''
												}}
											</td>
										</tr> -->
									</TheTable>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'Costs',
	components: { TheTable },
	data: function () {
		return {
			statsCostsTable: {
				selectedHeaders: [],
				headers: [
					{
						text: this.$t('fields.type'),
						value: 'type',
						type: 'dropdown|cost-types',
						allowFilter: true,
					},
					{
						text: this.$t('fields.teacher'),
						value: 'teacher',
						type: 'multiple|teachers',
						allowFilter: true,
					},
					{
						text: this.$t('fields.plannedCourse'),
						value: 'code',
						type: 'multiple|planned-courses',
						allowFilter: true,
					},
					{
						text: this.$t('fields.office'),
						value: 'office',
						type: 'select_all|offices',
						allowFilter: true,
					},
					{
						text: this.$t('fields.date'),
						value: 'date',
						type: '',
						allowFilter: true,
					},
					{
						text: this.$t('fields.unitPrice'),
						value: 'unit_price',
						type: '',
						allowFilter: true,
						alignRight: true,
					},
					{
						text: this.$t('fields.quantity'),
						value: 'quantity',
						type: '',
						allowFilter: true,
						alignRight: true,
					},
					{
						text: this.$t('fields.total'),
						value: 'total',
						type: '',
						allowFilter: true,
						alignRight: true,
					},
				],
				additionalFilters: [
					{ text: this.$t('fields.date'), value: 'date', type: 'date_range' },
					{ text: this.$t('fields.unitPrice'), value: 'unit_price', type: 'price_range' },
					{ text: this.$t('fields.quantity'), value: 'quantity', type: 'price_range' },
					{ text: this.$t('fields.total'), value: 'total', type: 'price_range' },
				],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'date',
					descending: true,
				},
			},
			incomeSum: 0,
			discountSum: 0,
		};
	},
	methods: {
		selectHeaders(headers) {
			this.statsCostsTable.selectedHeaders = headers;
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.statsCostsTable.lastRequest));
			excelRequest.pagination.itemsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall(
				'get',
				'stats-costs',
				excelRequest,
				(data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/stats-costs', data.items, (data, success) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		reloadData(request) {
			this.statsCostsTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'stats-costs',
				request,
				(data, success) => {
					if (success) {
						vm.statsCostsTable.items = data.items;
						vm.statsCostsTable.total = data.total;
						vm.incomeSum = data.income_sum;
						vm.discountSum = data.discount_sum;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.statsCostsTable.height = window.innerHeight - 325 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}
		this.$myStore.commit('setBreadcrumbs', [{ text: this.$t('modules.stats'), href: '/#/stats', disabled: true }]);

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
